import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getCSSVariableValue(variable: string) {
  const styles = getComputedStyle(document.documentElement);
  const value = styles.getPropertyValue(variable);
  return value;
}
